const convertBasketProductPriceBandsToGenericBands = (priceBands) => priceBands.map((band, idx) => ({
    ...band,
    Id: band.PriceBandId,
    FieldName: `PriceBands.${idx}.Units`,
}));
export default convertBasketProductPriceBandsToGenericBands;
